import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { initialsOf } from '@/components/ui';
import { useRailBadges } from './useRailBadges';
import { MobileHeader } from './MobileHeader';
import { MoreSheet } from './MoreSheet';
import { ClientMobileTabBar } from './ClientMobileTabBar';
import { clientPathnameToTabId, CLIENT_MORE_ITEMS } from './clientNav';
import { ContactSupportModal, useContactSupport } from './ContactSupportModal';

interface ClientMobileShellProps {
  history: { push: (path: string) => void; location: { pathname: string } };
  onLogout: () => void;
  children: React.ReactNode;
}

export const ClientMobileShell = ({
  history,
  onLogout,
  children,
}: ClientMobileShellProps) => {
  const [moreOpen, setMoreOpen] = useState(false);

  const data = useSelector((s: any) => s.loggedUser?.data) || {};
  const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim();
  const initials = initialsOf(fullName || data.emailAddress || '?');

  const { messages, notifications } = useRailBadges();
  const counts: Record<string, number> = { messages, notifications };

  const activeTabId = clientPathnameToTabId(history.location.pathname || '/');
  const moreActive = CLIENT_MORE_ITEMS.some((m) => m.id === activeTabId);

  const navigate = (path: string) => {
    history.push(path);
    setMoreOpen(false);
  };
  const { isContactSupportOpen, openContactSupport, closeContactSupport } =
    useContactSupport();

  return (
    <div className="tw-flex tw-flex-col tw-h-screen tw-w-full tw-overflow-hidden tw-relative">
      <MobileHeader
        initials={initials}
        name={fullName || data.emailAddress || ''}
        onAvatarClick={() => navigate('/profile')}
      />
      <div className="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-bg-white">
        {children}
      </div>
      <ClientMobileTabBar
        activeTabId={activeTabId}
        moreOpen={moreOpen}
        moreActive={moreActive}
        counts={counts}
        onNavigate={navigate}
        onToggleMore={() => setMoreOpen((v) => !v)}
      />
      <MoreSheet
        open={moreOpen}
        items={CLIENT_MORE_ITEMS}
        activeTabId={activeTabId}
        onNavigate={navigate}
        onClose={() => setMoreOpen(false)}
        onLogout={onLogout}
        showFeedback
        onContactSupport={openContactSupport}
      />
      <ContactSupportModal
        isOpen={isContactSupportOpen}
        onClose={closeContactSupport}
      />
    </div>
  );
};
